import styled from '@emotion/styled'
import React from 'react'
import { useChatContext } from './ChatProvider'

const BubbleButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  height: 48px;
  border-radius: 24px;
  background: #102638;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 18px 0 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9998;
  transition: transform 0.2s ease, background-color 0.2s ease;
  animation: bubbleIn 0.3s ease;

  @keyframes bubbleIn {
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:hover {
    transform: scale(1.05);
    background: #1a3a52;
  }
`

const KiteIcon = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
`

const Label = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`

const Badge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  font-size: 12px;
  font-weight: 600;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
`

const ChatBubble: React.FC = () => {
  const { isOpen, openChat, unreadCount } = useChatContext()

  if (isOpen) return null

  return (
    <BubbleButton onClick={openChat} aria-label="Open support chat">
      {unreadCount > 0 && <Badge>{unreadCount > 9 ? '9+' : unreadCount}</Badge>}
      <KiteIcon src="/img/email-kite-logo.png" alt="" />
      <Label>Get help</Label>
    </BubbleButton>
  )
}

export default ChatBubble
